import { CATEGORIAS_SERVICIO_CORTO, formatearMoneda, tienePrecioFijo } from "@uirtus/shared";
import { useMemo, useState } from "react";
import { useServicios, type Servicio } from "../lib/servicios";
import { Entrada, Modal } from "./ui";

interface Props {
  abierto: boolean;
  alCerrar: () => void;
  alSeleccionar: (servicio: Servicio) => void;
}

/**
 * El catálogo es de decenas de registros, no miles: se piden los activos de
 * un jalón y se filtra en el navegador, sin esperar red por cada tecla.
 */
export function SelectorServicio({ abierto, alCerrar, alSeleccionar }: Props) {
  const [texto, setTexto] = useState("");
  const { data } = useServicios({ activo: true });

  const filtrados = useMemo(() => {
    const lista = data ?? [];
    const t = texto.trim().toLowerCase();
    if (!t) return lista;
    return lista.filter(
      (s) =>
        s.nombre.toLowerCase().includes(t) ||
        s.clave.toLowerCase().includes(t) ||
        s.descripcion.toLowerCase().includes(t),
    );
  }, [data, texto]);

  return (
    <Modal
      titulo="Agregar servicio del catálogo"
      abierto={abierto}
      alCerrar={alCerrar}
      ancho="max-w-xl"
    >
      <div className="space-y-3 p-5">
        <Entrada
          autoFocus
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
          placeholder="Buscar por clave, nombre o descripción"
        />
        <div className="max-h-96 divide-y divide-slate-100 overflow-y-auto rounded-md border border-slate-200 dark:divide-slate-800 dark:border-slate-800">
          {filtrados.map((s) => (
            <button
              key={s.id}
              type="button"
              onClick={() => {
                alSeleccionar(s);
                alCerrar();
              }}
              className="block w-full px-3 py-2 text-left transition hover:bg-slate-50 dark:hover:bg-slate-800/50"
            >
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm font-medium">{s.nombre}</span>
                {tienePrecioFijo(s) && s.precioBase && (
                  <span className="shrink-0 font-mono text-xs text-slate-500">
                    {formatearMoneda(s.precioBase, s.moneda)}
                  </span>
                )}
              </div>
              <div className="text-xs text-slate-500">
                {s.clave} · {CATEGORIAS_SERVICIO_CORTO[s.categoria]}
                {!tienePrecioFijo(s) && " · se cotiza por proyecto"}
              </div>
            </button>
          ))}
          {filtrados.length === 0 && (
            <p className="px-3 py-6 text-center text-sm text-slate-500">
              Sin resultados. Puedes agregar un concepto libre.
            </p>
          )}
        </div>
      </div>
    </Modal>
  );
}
